/**
 * Tiny logger indirection for the setup-guide subsystem. Defaults to
 * console.warn so this package's unit tests don't need a browser env.
 *
 * The provider (Phase 2) wires this to datadogLogs at app startup via
 * setSetupGuideLogger() so production warnings go to the same place as
 * the rest of the merchant app's frontend logs.
 */
type WarnFn = (message: string, context: Record<string, unknown>) => void;

let warnImpl: WarnFn = (message, context) => {
  console.warn(message, context);
};

export function setSetupGuideLogger(fn: WarnFn): void {
  warnImpl = fn;
}

export function logSetupGuideWarn(
  message: string,
  context: Record<string, unknown>,
): void {
  warnImpl(message, context);
}

/** Test-only: restore the default console.warn implementation. */
export function _resetSetupGuideLoggerForTesting(): void {
  warnImpl = (message, context) => {
    console.warn(message, context);
  };
}
